<template>
  <footer
    v-show="!isLoggedIn"
    :class="{ 'footer-logged-out': !isLoggedIn }"
    class="footer w-100"
  >
    <div class="container pa-8">
      <div class="has-text-centered">
        <p class="text-center">
          STYLER -
          <span v-if="backendVersion !== ''">
            Backend v{{ backendVersion }} -
          </span>
          <span v-if="frontendVersion !== ''">
            Frontend v{{ frontendVersion }}
          </span>
          by <a href="https://brelag.com">Brelag Schweiz AG</a>.
        </p>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const backendVersion = computed(() => {
  return store.state.global.backendVersion
})

const isLoggedIn = computed(() => {
  return store.state.global.isLoggedIn
})

const frontendVersion = computed(() => {
  return store.state.global.frontendVersion
})
</script>
